import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Building2, House, Sparkles, Briefcase, Truck, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Solar Panel Cleaning",
  description: "Professional cleaning using specialised purified water systems to remove dust and pollutants, restoring your panels to peak efficiency.",
  icon: Sparkles,
  href: "/ServicesPage"
}, {
  title: "Residential Solar",
  description: "Safe, effective cleaning for home solar systems. We help homeowners maximise their renewable energy savings every single month.",
  icon: House,
  href: "/ServicesPage"
}, {
  title: "Commercial Solar",
  description: "Large-scale cleaning solutions for businesses and solar farms. Minimize energy loss and maximise your commercial solar ROI.",
  icon: Building2,
  href: "/ServicesPage"
}, {
  title: "Bird Debris Removal",
  description: "Specialised removal of bird droppings and nesting materials that can cause permanent hot-spot damage to your solar cells.",
  icon: ShieldCheck,
  href: "/ServicesPage"
}, {
  title: "Safe Professional Cleaning",
  description: "We use purified water systems and professional equipment to safely clean your panels without harsh chemicals or hard water stains.",
  icon: Briefcase,
  href: "/ServicesPage"
}, {
  title: "Improve Solar Efficiency",
  description: "Dirty panels can lose up to 20–25% efficiency. Regular cleaning ensures your solar system operates at peak performance year-round.",
  icon: Truck,
  href: "/ServicesPage"
}];
export default function ExpertCleaningSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19983" id="specialized-solar-care" ref={ref} className="bg-background py-20 lg:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className={cn("mb-12 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl font-sans mb-4">Specialised Solar Care</h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">Maximise your energy output and protect your investment with our professional cleaning and maintenance solutions.</p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {services.map((service, index) => <div key={index} data-index={index} className={cn("transition-all duration-700 ease-out delay-[var(--delay)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
          "--delay": `${index * 100}ms`
        } as React.CSSProperties}>
              <Card className="group relative h-full overflow-hidden border-none bg-transparent shadow-none transition-all duration-300 hover:-translate-y-1">
                <CardContent className="flex h-full flex-col p-8">
                  <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary transition-all duration-500 group-hover:bg-primary/20 group-hover:scale-110 shadow-[0_0_20px_rgba(255,191,0,0.05)] group-hover:shadow-[0_0_30px_rgba(255,191,0,0.2)]">
                    <service.icon className="h-7 w-7" strokeWidth={2} />
                  </div>
                  
                  <h3 className="mb-3 font-sans text-[22px] font-bold text-foreground tracking-tight">
                    {service.title}
                  </h3>
                  
                  <p className="mb-6 flex-grow text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                  
                  <div className="mt-auto">
                    <Link to={service.href} className="group/link inline-flex items-center text-sm font-bold text-primary transition-colors hover:text-primary/80 uppercase tracking-wider">
                      Learn More
                      <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}